import React from 'react';

function NameHeaderComponent() {
  return (
    <section className='grid items-center pt-12'>
      <h1 className='text-colour1 dark:text-colour1 text-6xl lg:text-9xl tracking-widest'>
        <div className='font-titleFont bg-colour2'>QUEEN</div>
        <div className='lg:-mt-4 delay font-titleFont bg-colour2'>BLAIRE</div>
      </h1>
    </section>
  );
}

export default NameHeaderComponent;
